//export const CONTRACT_ADDRESS = '0x4181BbF394A5c929A20568609b61fD294C58a66a';
//export const CHAIN_ID = '0x4';
export const CONTRACT_ADDRESS = '0xB9E6c76c1D481d9E80d1F31DfA5A3A1B8f1B0014';
export const CHAIN_ID = '0x13881';
